import React from 'react'
/* COMPONENTS */
import BPIcon from '../BPIcon'

const GridCell = React.memo(({ icon, className, data, tooltip, intent, onClick, prependText, appendText, iconSize }) => {
  return (
    <>
      {prependText && <span className='pr-2'>{prependText}</span>}
      <BPIcon
        icon={icon}
        iconSize={iconSize}
        className={className}
        tooltip={tooltip}
        intent={intent}
        onClick={() => {
          onClick && onClick(data)
        }}
      />
      {appendText && <span className='pl-2'>{appendText}</span>}
    </>
  )
})

export default GridCell
